/**
 * The `DisplayCaptureSurfaceType` enumeration describes the different types of
 * display surface
 *
 * @see {@link https://w3c.github.io/mediacapture-screen-share/#displaycapturesurfacetype}
 */
export const DISPLAY_CAPTURE_SURFACE_TYPE = {
    Monitor: 'monitor',
    Window: 'window',
    Browser: 'browser',
};
/**
 * The `CursorCaptureConstraint` enumerates the conditions under which the
 * cursor is captured.
 *
 * @see {@link https://w3c.github.io/mediacapture-screen-share/#cursorcaptureconstraint}
 */
export const CURSOR_CAPTURE_CONSTRAINT = {
    Never: 'never',
    Always: 'always',
    Motion: 'motion',
};
export const INCLUDE_EXCLUDE_CONSTRAINT = {
    Include: 'include',
    Exclude: 'exclude',
};
export const DEVICE_ID_SEPARATOR = ':';
